import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=772d8544&"
import script from "./DetailHeader.vue?vue&type=script&lang=ts&"
export * from "./DetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DetailHeader.vue?vue&type=style&index=0&id=772d8544&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports